import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { datadogRum } from '@datadog/browser-rum';

import { DATADOG_SERVICE } from '.';

export const DatadogRouterTracker = (): null => {
    const location = useLocation();

    useEffect(() => {
        try {
            datadogRum.startView({
                name: location.pathname,
                service: DATADOG_SERVICE
            });
        } catch {
            // Silently catch errors to prevent app crashes
        }
    }, [location.pathname]);

    return null;
};
